/* eslint-disable global-require, import/no-dynamic-require */
// @flow
import React from 'react';
import PropTypes from 'prop-types';

import './TileGridContent.scss';

type Props = {
  disabled: boolean,
  image: string,
  title: string,
  click: (void) => void,
};

/**
 * TileGrid content with an image and a click event
 */
const TileGridContentComponent = ({ disabled, image, title, click }: Props) => (
  <div
    className={`tile-grid-content-component ${disabled ? 'tile-grid-content-component--disable' : ''}`}
    onClick={disabled ? null : click}
  >
    <img className="tile-grid-content-component__image" src={require(`../../assets/${image}`).default || require(`../../assets/${image}`)} alt={title} />
    <div className="tile-grid-content-component__title u-fontFamily-primaryMedium">{title}</div>
  </div>
);

TileGridContentComponent.displayName = 'TileGridContent';

TileGridContentComponent.propTypes = {
  disabled: PropTypes.bool,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  click: PropTypes.func,
};

TileGridContentComponent.defaultProps = {
  disabled: false,
  click: () => {},
};

export default TileGridContentComponent;
